import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/BookNow.css';
import logo from '../assets/logo3.webp';
import bookingImg from '../assets/bookings.png'; 

const BookNow = () => {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
const handleSubmit = async (e) => {
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);
  const formBody = new URLSearchParams(formData);

  try {
    const response = await fetch('https://formsubmit.co/info@travelkariye.com', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formBody.toString(),
    });

    if (response.ok) {
      setShowPopup(true);
      form.reset();
      setTimeout(() => {
        setShowPopup(false);
        navigate('/');
      }, 2000);
    } else {
      console.error('FormSubmit Error:', await response.text());
    }
  } catch (error) {
    console.error('Submission failed:', error);
  }
};

  return (
    <>
     <header className="booknow-header over-banner">
        <div className="booknow-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="booknow-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="booknow-dropdown">
            <a href="#" className="booknow-dropbtn">Destinations</a>  
<div className="booknow-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                              <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
            <Link to="/hotels">Hotels</Link>
        <Link to="/contact-us">Contact Us</Link>
        </nav>
        <button className="booknow-book-btn">Book Now</button>
      </header>

      <div className="booknow-wrapper">
        <div className="booknow-card">
          <div className="form-section">
            <h2>Book Your Trip</h2>
            <p>Fill in your travel details below:</p>
           <form onSubmit={handleSubmit}>
  <input type="hidden" name="_captcha" value="false" />
  <input type="hidden" name="_template" value="table" />

  <input type="text" name="name" placeholder="Full Name" required />
  <input type="email" name="email" placeholder="Email Address" required />
  <input type="tel" name="phone" placeholder="Phone Number" required />
  <input type="text" name="destination" placeholder="Destination or Package Name" required />
  <div class="form-group">
     <label for="checkin" class="premium-label">Check-In</label>
  <input type="date" id="checkin" name="checkin" required />
      <label for="checkout" class="premium-label">Check-Out</label>
  <input type="date" id="checkout" name="checkout" required />
  </div>
  <input type="number" name="guests" placeholder="Number of Guests" min="1" required />
  <textarea name="preferences" rows="4" placeholder="Special Requests (optional)"></textarea>
  <button type="submit">Confirm Booking</button>
</form>

          </div>

          <div className="info-section">
            <img src={bookingImg} alt="Booking Banner" className="booknow-image" />
          </div>
        </div>

        {showPopup && (
          <div className="popup-overlay">
            <div className="popup-box">
              <p>Your booking request has been submitted!</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BookNow;
